"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Emitter =
/*#__PURE__*/
function () {
  function Emitter() {
    var _this = this;

    (0, _classCallCheck2.default)(this, Emitter);
    (0, _defineProperty2.default)(this, "components", []);
    (0, _defineProperty2.default)(this, "clickListener", function (e) {
      if (e.target === document.body) {
        // Chrome from version 73 starts send click events from body if is not visible, or hidden by other element
        // so do nothing in this case
        return;
      }

      var item = _this.components.find(function (c) {
        return c.isActive();
      });

      if (item && item.isOuter(e.target) && item.outerClick(e) !== false) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }

  (0, _createClass2.default)(Emitter, [{
    key: "add",
    value: function add(item) {
      this.components.unshift(item);
      this.register();
    }
  }, {
    key: "remove",
    value: function remove(item) {
      this.components = this.components.filter(function (component) {
        return component !== item;
      });
      this.unregisterIfNeed();
    }
  }, {
    key: "register",
    value: function register() {
      if (!this.registered) {
        document.addEventListener('click', this.clickListener, true);
        this.registered = true;
      }
    }
  }, {
    key: "unregisterIfNeed",
    value: function unregisterIfNeed() {
      if (this.registered && this.components.length === 0) {
        document.removeEventListener('click', this.clickListener, true);
        this.registered = false;
      }
    }
  }]);
  return Emitter;
}();

var emitter = new Emitter();

var OuterClick =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(OuterClick, _React$PureComponent);

  function OuterClick() {
    var _getPrototypeOf2;

    var _this2;

    (0, _classCallCheck2.default)(this, OuterClick);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(OuterClick)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this2)), "ref", function (element) {
      _this2.element = element;
      _this2.props.onRef && _this2.props.onRef(element);
    });
    return _this2;
  }

  (0, _createClass2.default)(OuterClick, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      emitter.add(this);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      emitter.remove(this);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.props.children && this.element && this.props.onOuterClick;
    }
  }, {
    key: "isOuter",
    value: function isOuter(node) {
      return node !== this.element && !this.element.contains(node);
    }
  }, {
    key: "outerClick",
    value: function outerClick(e) {
      return this.props.onOuterClick && this.props.onOuterClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _extends2.default)({}, this.props, {
        ref: this.ref
      });
      delete props.onOuterClick;
      delete props.onRef;
      return _react.default.createElement("div", props);
    }
  }]);
  return OuterClick;
}(_react.default.PureComponent);

exports.default = OuterClick;
OuterClick.propTypes = process.env.NODE_ENV !== "production" ? {
  onOuterClick: _propTypes.default.func,
  onRef: _propTypes.default.func
} : {};